<template>
    <button type="button" class="btn w-100" :class="{'btn-info': checked}" @click="submit">Beobachten</button>
</template>

<script>
    export default {
        props: {
            pid: {
                type: [String, Number],
                required: true,
                default: null
            },
            refresh: {
                type: [Boolean],
                required: false,
                default: false
            }
        },

        data () { 
            return {
                checked: false,
                enabled: false,
                items: {},
                rowId: 0
            }
        },

        created() {
            App.event.listen('watch-list.data.loaded', (response) => {
                this.enabled = true;
                this.items = response.items;


                var size = 0, key;
                for (key in this.items) {
                    if (this.items.hasOwnProperty(key)) size++;
                }

                for(let i = 0; i<size; i++) {
                    if(this.pid == this.items[i].product_id) {
                        this.rowId = this.items[i].product_id;
                        this.checked = true;
                    }
                }
            });
        },

        methods: {

            submit() {

                new Form().get('/api/me')
                    .then(user => {
                        if(user != "") {
                            if(this.checked == false) {
                                new Form({
                                    pid: this.pid
                                })
                                .post('/api/product/add-to-watch-list')
                                .then((response) => {
                                    this.checked = true;
                                    this.rowId = response.rowId;
                                    App.event.fire('watch-list.updated', response.content);
                                })
                            } else {
                                new Form({
                                    rowId: this.rowId
                                })
                                .post('/api/product/remove-from-watch-list')
                                .then((response) => {
                                    this.loading = false;
                                    this.checked = false;
                                    if(this.refresh) {
                                        location.reload();
                                    } else {
                                        App.event.fire('watch-list.updated', response);
                                    }
                                })
                            }
                        } else {
                            App.event.fire('show-login', this.pid);
                        }
                    })
            }
        }
    }
</script>
